
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
name: 'bottombar',
data () {
return {
p: '/home'
}
},
components: {
Tabbar, TabbarItem
},
watch: {
'$route': function (val) {
this.p = val.path
}
},
mounted () {
this.p = this.$route.path
}
}



// WEBPACK FOOTER //
// ./src/layout/Bottombar.vue